export const badgeDefaultStyle = theme => ({
  display: 'inline-block',
  fontFamily: theme.tokens.ComponentBadgeFontName,
  fontSize: theme.tokens.ComponentBadgeFontSize,
  lineHeight: theme.tokens.ComponentBadgeFontLineHeight,
  textAlign: 'center',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  fontWeight: theme.tokens.ComponentBadgeFontWeight,
  borderRadius: theme.tokens.ComponentBadgeBorderRadius,
  boxSizing: 'border-box'
});
export const badgeContainerStyle = theme => ({
  display: 'flex',
  gap: '4px',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '4px 10px',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
});